module.exports = __webpack_public_path__ + "static/img/home-banner.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-banner.png
// module id = 166
// module chunks = 0